<template>
  <div>
    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Setup</el-breadcrumb-item>
          <el-breadcrumb-item>Factory</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card>
<!--      <el-form :inline="true" :model="formInline" class="demo-form-inline">-->
<!--        <el-form-item>-->
<!--          <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
      <el-table :data="roleList" border stripe style="width: 100%">
        <!--          <el-table-column type="index" label="#"></el-table-column>-->
        <el-table-column
          prop="id"
          label="Factory Id"         sortable
          width="150">
        </el-table-column>
        <el-table-column
          prop="supplier"
          label="Supplier Name"         sortable
          width="150">
        </el-table-column>
        <el-table-column
          prop="location"
          label="Location" sortable
          width="150">
        </el-table-column>
        <el-table-column label="Operation" width="">
          <template slot-scope="index">
            <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
<!--            <el-button type="info" plain size="mini" @click="getOutputCalendar(index)">Output Calendar</el-button>-->

            <el-button type="info" plain size="mini" @click="getMachineList(index)"><i class="el-icon-receiving"></i> Machine
<!--              <span style="color: green">28</span> <span style="color: orangered">2</span>-->
            </el-button>
            <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
<!--            <el-button type="info" plain size="mini" @click="edit(index)">Edit</el-button>-->
            <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
          </template>
        </el-table-column>

      </el-table>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Factory',
  data () {
    return {
      roleList: []
    }
  },
  created () {
    this.getFactoryList()
  },
  methods: {
    getOutputCalendar (index) {
      this.$router.push(`/followup?id=${index.row.id}&supplier=${index.row.supplier}&location=${index.row.location}`)
    },
    getMachineList (index) {
      console.log(index.row.id)
      this.$router.push(`/machine?id=${index.row.id}&supplier=${index.row.supplier}&location=${index.row.location}`)
    },
    async getFactoryList () {
      const { data: res } = await this.$http.get('/factory/getFactoryList', { params: this.formInline })
      this.roleList = res
      this.total = res.total
    }
  }
}
</script>

<style scoped>

</style>
